import { render } from "./NotificationBox.vue?vue&type=template&id=4712dfd2"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"

import "./NotificationBox.vue?vue&type=style&index=0&id=4712dfd2&lang=scss"

import exportComponent from "D:\\angren\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__